import React from 'react'

function LetsTalk() {
  return (
    <div>LetsTalk</div>
  )
}

export default LetsTalk